import { AbstractControl } from '@angular/forms';
import { clearMaskedFieldOnKeydown, clearMaskedFieldOnPaste } from './masked-field';

/** Backend returns this when a DOB is on file but must not be revealed in plaintext. */
export const MASKED_DOB = '**/**/****';

/**
 * ngx-mask patterns for `M0/d0/0000`: digits for entry, asterisks so a masked
 * backend value can render. Replaces the default pattern map when passed to [patterns].
 */
export const dobReplacePattern = {
  '0': { pattern: new RegExp(/[\d*]/) },
  M: { pattern: new RegExp(/[\d*]/) },
  d: { pattern: new RegExp(/[\d*]/) },
};

export function isMaskedDob(value: unknown): boolean {
  if (typeof value !== 'string' || !value) {
    return false;
  }
  return value === MASKED_DOB;
}

export function clearMaskedDobOnKeydown(
  control: AbstractControl | null | undefined,
  event: KeyboardEvent
): void {
  clearMaskedFieldOnKeydown(control, event, isMaskedDob);
}

export function clearMaskedDobOnPaste(
  control: AbstractControl | null | undefined,
  event?: ClipboardEvent
): void {
  clearMaskedFieldOnPaste(control, isMaskedDob, event);
}
